// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","button":"J-v5G","label":"_16Lq-","iconPlus":"_3UBo9"};